import Email6 from './Email6'
export default Email6
